export var AvailableScrollDirection;
(function (AvailableScrollDirection) {
  AvailableScrollDirection[AvailableScrollDirection["Top"] = 0] = "Top";
  AvailableScrollDirection[AvailableScrollDirection["Bottom"] = 1] = "Bottom";
  AvailableScrollDirection[AvailableScrollDirection["Both"] = 2] = "Both";
})(AvailableScrollDirection || (AvailableScrollDirection = {}));
export function getAvailableScrollDirection(e) {
  var _ref = e.target,
    scrollTop = _ref.scrollTop,
    scrollHeight = _ref.scrollHeight,
    offsetHeight = _ref.offsetHeight;
  var scroll = scrollHeight - offsetHeight;
  var canScrollToTop = scrollTop !== 0;
  var canScrollToBottom = scrollTop !== scroll;
  var availableScrollDirection;
  if (canScrollToBottom) {
    availableScrollDirection = AvailableScrollDirection.Bottom;
  }
  if (canScrollToTop) {
    availableScrollDirection = AvailableScrollDirection.Top;
  }
  if (canScrollToTop && canScrollToBottom) {
    availableScrollDirection = AvailableScrollDirection.Both;
  }
  return availableScrollDirection;
}